import { createFileRoute } from '@tanstack/react-router';
import {
  Typography,
  Paper,
  Box,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

export const Route = createFileRoute('/about')({
  component: AboutComponent,
});

function AboutComponent() {
  return (
    <Box>
      <Typography variant='h4' component='h1' gutterBottom>
        About TanStack Router Setup
      </Typography>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant='h6' gutterBottom>
          Router Configuration Features
        </Typography>

        <List>
          <ListItem>
            <ListItemText
              primary='File-based Routing'
              secondary='Routes are automatically generated from the file structure in src/routes/'
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary='Type-safe Parameters'
              secondary='Route parameters and search params are validated with Zod schemas'
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary='Error Boundaries'
              secondary='Each route can have its own error handling and fallback UI'
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary='Loading States'
              secondary='Pending components show loading states during navigation'
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary='Nested Layouts'
              secondary='Layout routes provide shared UI structure for child routes'
            />
          </ListItem>
          <ListItem>
            <ListItemText
              primary='404 Handling'
              secondary='Not found routes are handled gracefully with custom UI'
            />
          </ListItem>
        </List>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant='h6' gutterBottom>
          Available Routes
        </Typography>

        <List dense>
          <ListItem>
            <ListItemText primary='/ - Home page' />
          </ListItem>
          <ListItem>
            <ListItemText primary='/auth/login - Login page' />
          </ListItem>
          <ListItem>
            <ListItemText primary='/projects - Projects list' />
          </ListItem>
          <ListItem>
            <ListItemText primary='/projects/:projectId - Project details with type-safe ID' />
          </ListItem>
          <ListItem>
            <ListItemText primary='/sites - Sites list' />
          </ListItem>
          <ListItem>
            <ListItemText primary='/search - Search with type-safe query parameters' />
          </ListItem>
          <ListItem>
            <ListItemText primary='/about - This page' />
          </ListItem>
          <ListItem>
            <ListItemText primary='/404 - Not found page' />
          </ListItem>
        </List>
      </Paper>
    </Box>
  );
}
